import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-floor-dialog',
  templateUrl: './manual-floor-dialog.component.html',
  styleUrls: ['./manual-floor-dialog.component.css'],
  standalone: false,
})
export class ManualFloorDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly nameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;
  readonly descDialogLink: string = AppConst.ROUTING_LINK_MANUAL_DESC_DIALOG;
  readonly uploaderLink: string = AppConst.ROUTING_LINK_MANUAL_UPLOADER;
  readonly hallDialogLink: string = AppConst.ROUTING_LINK_MANUAL_HALL_DIALOG;
  readonly exhibitDialogLink: string = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_DIALOG;
  readonly urlDialogLink: string = AppConst.ROUTING_LINK_MANUAL_URL_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
